import { Component, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { Observable } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { LoginStatusSelector } from 'src/app/app-store/login/login.selector';
import { previousURLSelector, TabSelector } from 'src/app/app-store/user/user.selector';
import { MapService } from '../services/map.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css'],
})
export class ToolbarComponent implements OnInit {

  @Output() public sidenavToggle = new EventEmitter();

  drawerToggleIcon = 'assets/icons/menu.png';
  slbSafeImage = 'assets/icons/logo2.svg';
  slbSafeImageMobile1 = 'assets/icons/slbMobilelogo2.svg';
  slbSafeImageMobile = 'assets/icons/logomobile.png';

  classTranparent = 'background toolbar-normal transparent';
  classTranparentMobile = 'background toolbar-xs transparent';
  classNormal = 'background toolbar-normal';
  classMobile = 'background toolbar-xs';
  cssMobile: string;
  cssNormal: string;
  loginStatus: boolean;
  showBack: boolean;
  url: string;
  selectedTab: string;
  isHistory: boolean;
  showTemplateSingleWord: boolean;
  showTemplateDoubleWord: boolean;
  showSuperAdmin: boolean;
  showTemplateTripleWord: boolean;
  showSettings: boolean;
  showTemplateWithBackButton: boolean;
  showSingleWordTemplateWithBackButton: boolean;
  showTemplateWithBackAndThreeLetterButton: boolean;
  proxy: boolean;
  layoutGapxs: string;
  toolbarTitle: Observable<string>;
  showContactTracing: boolean;
  showMyCertifications: boolean;

  constructor(
    private router: Router,
    private mapService: MapService,
    private store: Store) { }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    if (window.innerWidth >= 320 && window.innerWidth <= 350) {
      this.layoutGapxs = '13vw';
    } else if (window.innerWidth > 350 && window.innerWidth <= 380) {
      this.layoutGapxs = '20vw';
    } else {
      this.layoutGapxs = '25vw';
    }
  }

  ngOnInit() {
    this.toolbarTitle = this.mapService.getToolbarTitle();

    this.routeChanges();
    this.getScreenSize();
    this.store.pipe(select(LoginStatusSelector)).subscribe(response => {
      this.loginStatus = response;
    });
    this.store.pipe(select(previousURLSelector)).subscribe(response => {
      this.url = response;
    });
    this.store.pipe(select(TabSelector)).subscribe(response => {
      this.selectedTab = response;
    });

  }

  onBack() {
    const splitUrl = this.url.split('?');
    const params = [];
    splitUrl[1]?.split('&')?.filter((i) => params.push(i.split('=')));
    if (params.length > 0) {
      const paramsResult = {};
      params.forEach(item => {
        paramsResult[item[0]] = item[1];
      });
      this.router.navigate([splitUrl[0]], { queryParams: paramsResult, replaceUrl: true });
    } else {
      this.router.navigateByUrl(this.url, { replaceUrl: true });
    }
  }

  public onToggleSidenav = () => {
    this.sidenavToggle.emit();
  }

  // Function to listen for route changes;

  routeChanges = () => {

    // Subscribe to router events
    this.router.events.subscribe(response => {
      // Check response to be an instance of NavigationEnd
      if (response instanceof NavigationEnd) {

        if (response.url === '/history' ||
          response.url.includes('/inviteuser')) {
          this.showBack = false;
          this.showTemplateSingleWord = true;
          this.showTemplateTripleWord = false;
          this.showTemplateDoubleWord = false;
          this.showTemplateWithBackButton = false;
          this.showSingleWordTemplateWithBackButton = false;
          this.showTemplateWithBackAndThreeLetterButton = false;

        } else if (response.url.includes('/admin') ||
          response.url.includes('/settings') ||
          response.url.includes('/userguide') ||
          response.url.includes('/scanqr')) {
          this.showBack = false;
          this.showTemplateSingleWord = false;
          this.showTemplateTripleWord = false;
          this.showTemplateDoubleWord = true;
          this.showTemplateWithBackButton = false;
          this.showSingleWordTemplateWithBackButton = false;
          this.showTemplateWithBackAndThreeLetterButton = false;

        } else if (response.url.includes('/approvals')) {
          this.showBack = true;
          this.showTemplateSingleWord = false;
          this.showTemplateTripleWord = false;
          this.showTemplateDoubleWord = false;
          this.showTemplateWithBackButton = false;
          this.showSingleWordTemplateWithBackButton = true;
          this.showTemplateWithBackAndThreeLetterButton = false;

        } else if (response.url.includes('/siteredinessmatrix')) {
          this.showBack = false;
          this.showTemplateSingleWord = false;
          this.showTemplateTripleWord = true;
          this.showTemplateDoubleWord = false;
          this.showTemplateWithBackButton = false;
          this.showSingleWordTemplateWithBackButton = false;
          this.showTemplateWithBackAndThreeLetterButton = false;

        } else if (response.url.includes('/sitecreatereq') ||
          response.url.includes('/qrdetails') ||
          response.url.includes('/siteapprovaldetails') ||
          response.url.includes('/reqdetails') ||
          response.url.includes('/traveldetails') ||
          response.url.includes('/travelrequest') ||
          response.url.includes('/travelapprovaldetails') ||
          response.url.includes('/contacttracing') ||
          response.url.includes('mycertifications')) {
          this.showBack = true;
          this.showTemplateSingleWord = false;
          this.showTemplateTripleWord = false;
          this.showTemplateDoubleWord = false;
          this.showTemplateWithBackButton = true;
          this.showSingleWordTemplateWithBackButton = false;
          this.showTemplateWithBackAndThreeLetterButton = false;

        } else if (response.url.includes('/createtravelrequest') || response.url.includes('/sendtraveldetails') || response.url.includes('/countryinformation')) {
          this.showBack = true;
          this.showTemplateSingleWord = false;
          this.showTemplateTripleWord = false;
          this.showTemplateDoubleWord = false;
          this.showTemplateWithBackButton = false;
          this.showSingleWordTemplateWithBackButton = false;
          this.showTemplateWithBackAndThreeLetterButton = true;

        } else if (response.url === '/detail' || response.url.includes('/proxyaddmember') || response.url.includes('/grpdetail')) {
          this.proxy = true;
          if (response.url.includes('isRequest')) {
            this.proxy = false;
          }
          this.showBack = true;
        }
        else {
          this.proxy = false;
          this.showBack = false;
          this.showTemplateSingleWord = false;
          this.showTemplateTripleWord = false;
          this.showTemplateDoubleWord = false;
          this.showSingleWordTemplateWithBackButton = false;
          this.showTemplateWithBackButton = false;
          this.showTemplateWithBackAndThreeLetterButton = false;
        }

        if (response.url.includes('dashboard') ||
          response.url.includes('internal') ||
          response.url.includes('external') ||
          response.url.includes('login') ||
          response.url.includes('forgotpassword') ||
          response.url.includes('resetpassword') ||
          response.url.includes('register') ||
          response.url === '/') {
          this.cssMobile = this.classTranparentMobile; // CSS tranparent for mobile
          this.cssNormal = this.classTranparent; // CSS transparent for normal devices
        } else {
          this.cssNormal = this.classNormal; // CSS for normal devices
          this.cssMobile = this.classMobile; // CSS for mobile
        }
      }
    });
  }
}
